export interface OmnitureData {
  [x: string]: string;
}

export enum OmnitureLinkType {
  CUSTOM_LINK = 'o',
  EXIT_LINK = 'e',
  FILE_DOWNLOAD = 'd',
}
